<p-card appearance="outlined" fxLayout="column">
    <!-- <div class="title font-size-16">
        {{ "APP_CASES.DUPLICATION_CASE_LIST" | translate }}
    </div> -->
    <!-- Responsive Header Container -->
    <div class="card-header-container">
        <!-- Title -->
        <div
            class="title font-size-16"
            tooltipPosition="top"
            [pTooltip]="'APP_CASES.DUPLICATION_CASE_LIST' | translate"
        >
            {{ "APP_CASES.DUPLICATION_CASE_LIST" | translate }}
        </div>

        <!-- Status Labels & Action Buttons Container -->
        @if (isRepairCaseTableSelected) {
            <div class="status-actions-container">
                <!-- Pending Label -->
                <div
                    *ngIf="isPendingRepairCaseConnection"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="3px"
                    class="pending-label"
                >
                    <i
                        tooltipPosition="top"
                        [pTooltip]="'APP_CASES.PENDING' | translate"
                        class="pi pi-exclamation-triangle"
                    ></i>
                    <span>{{ "APP_CASES.PENDING" | translate }}</span>
                </div>

                <!-- Failed Label -->
                <div
                    *ngIf="isFailedRepairCaseConnection"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="0px"
                    class="failed-label"
                >
                    <i
                        tooltipPosition="top"
                        [pTooltip]="'APP_CASES.FAILED' | translate"
                        class="pi pi-exclamation-triangle"
                    ></i>
                    <span>{{ "APP_CASES.FAILED" | translate }}</span>
                </div>

                <!-- Retry Button -->
                <p-button 
                    *ngIf="isRetryRepairCaseConnection"
                    label="{{ 'APP_CASES.RETRY' | translate }}"
                    icon="pi pi-refresh"
                    class="retry-btn"
                    (onClick)="onRetryRepairCaseConnection()"
                />
            </div>
        }
    </div>

    <p-tabs value="0" scrollable (valueChange)="onTabChange($event)">
        <p-tablist >
            <p-tab value="0" class="flex items-center !gap-2">
                <span class="font-bold whitespace-nowrap"
                    >{{ "APP_CASES.AUDIT_CASES" | translate }} ({{ data?.length || 0 }})
                </span>
            </p-tab>
            <p-tab value="1" class="flex items-center">
                <span class="font-bold whitespace-nowrap"
                    >{{ "APP_CASES.REPAIR_CASES" | translate }} ({{ duplicateClaimCaseList?.length || 0 }})</span
                >
            </p-tab>
            <p-tab value="2" class="flex items-center" *ngIf="isFraudSectionVisible">
                <span class="font-bold whitespace-nowrap"
                    >{{ "APP_CASES.FRAUD_CASES" | translate }} ({{ finalFraudCaseList?.length || 0 }})</span
                >
            </p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="0">
                <app-app-basic-list
                    [bgColor]="bgColor"
                    [data]="data"
                    [titleDisplay]="titleDisplay"
                    [subTitleDisplay]="subTitleDisplay"
                    [rootRoute]="rootRoute"
                    [header]="header"
                    [truncate]="truncate"
                    [isRadioButtonAvailable]="true"
                    [selectedItemIds]="selectedItemIds"
                    [unSelectedItem]="unSelectedItem"
                    [source]="source"
                    (outputForDuplicateCaseOrEmail)="outputForDuplicateCaseOrEmail.emit($event)"
                    [isHeaderNeedToShow]="false"
                ></app-app-basic-list>

                <p
                    *ngIf="data?.length > 0 && !isDisconnectionButtonVisible"
                    class="warning-text-disconnect font-size-8"
                >
                    {{ "*" }}{{ "APP_CASES.DISCONNECT_CASE_WARNING_FOR_CREATE_AND_UPDATE" | translate }}
                </p>

                <div fxLayout="row" fxLayoutAlign="space-between end" *ngIf="isDisconnectionButtonVisible">
                    <div></div>
                    <p-button label="{{ 'APP_CASES.DISCONNECT' | translate }}" (click)="onDisconnect()" />
                </div>
            </p-tabpanel>
            <p-tabpanel value="1">
                <app-connected-repair-cases
                    [duplicateClaimCaseList]="duplicateClaimCaseList"
                ></app-connected-repair-cases>
            </p-tabpanel>
            <p-tabpanel value="2" *ngIf="isFraudSectionVisible">
                <app-app-basic-list
                    [bgColor]="bgColor"
                    [data]="finalFraudCaseList"
                    [titleDisplay]="titleDisplay"
                    [subTitleDisplay]="subTitleDisplay"
                    [rootRoute]="rootRoute"
                    [header]="'APP_CASES.FRAUD_CASES'"
                    [truncate]="truncate"
                    [isRadioButtonAvailable]="true"
                    [selectedItemIds]="selectedFraudCaseItemIds"
                    [unSelectedItem]="false"
                    [isHeaderNeedToShow]="false"
                    (outputForDuplicateCaseOrEmail)="onChangeFraudCase($event)"
                ></app-app-basic-list>
                <p *ngIf="finalFraudCaseList?.length > 0" class="warning-text-disconnect font-size-8">
                    {{ "*" }}{{ "APP_CASES.DISCONNECT_CASE_WARNING_FOR_CREATE_AND_UPDATE" | translate }}
                </p>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</p-card>
